import type {
  SubscriptionType,
  ISubscriptionInfo,
  Artist,
} from 'services/api/entities';
import { Nullable } from 'types';
import { Song } from '../songs/types';

export enum DownloadLimitStatus {
  Enabled = 'enabled',
  Warning = 'warning',
  Disabled = 'disabled',
}

export type DownloadLimit = {
  status: DownloadLimitStatus;
  remaining: number;
  daysToDownloadLimitReset: number;
};

export type UserStore = {
  id: string;
  email: string;
  firstName: Nullable<string>;
  lastName: Nullable<string>;
  profileImagePath: string;
  roles: Array<string>;
  emailConfirmed: boolean;
  isMuted: boolean;
  createdAt: Date | null;
  subscription: Nullable<ISubscriptionInfo>;
  subscriptionType: Nullable<SubscriptionType>;
  hasDistribution: boolean;
  songDownloadLimit: Nullable<DownloadLimit>;
  stemsDownloadLimit: Nullable<DownloadLimit>;
  samplePackDownloadLimit: Nullable<DownloadLimit>;
  aiGenerationLimit: Nullable<DownloadLimit>;
  submitReleaseLimit: Nullable<DownloadLimit>;
  studioExportLimit: Nullable<DownloadLimit>;
  uploadAudioLimit: Nullable<DownloadLimit>;
  songsLibrary: {
    page: number;
    songs: Record<string, Song>;
    newSongsInLibrary: boolean;
    songListPosition: number;
    ids: Array<string>;
  };
  artists: Artist[];
};
